import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import ModalSelectDocument from '../controls/ModalSelectDocument';
import Tools from '../tools/tools';
import ModalMail from '../controls/ModalMail';
import ModalMailShow from '../controls/ModalMailShow';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import keycloak from '../tools/keycloak';
import VacationList from '../parts/VacationList';
import VacationEdit from '../parts/VacationEdit';


const Vacations = () => {
    let [rec, setRec] = useState(null);
    let [refresh, setRefresh] = useState(new Date());
    let [users, setUsers] = useState([]);
    useEffect(() => {
        Comm.Instance().get(`user`).then(result => {
            setUsers(result.data);
            console.log("user", result.data);

        }).catch(error => Tools.ProcessError(error))
    }, []);

    const setFunc = (prop, value) => {
        rec[prop] = value;
        setRec({ ...rec });
    }

    const newVacation = () => {
        setRec({
            who: "0",
            replace: "0",
            fromDate: new Date(),
            toDate: new Date()
        })
    }

    const editVacation = (item) => {
        setRec(item)
    }

    const save = () => {
        if (rec.vacationId) {
            Comm.Instance().put("Vacation", rec).then(r => refreshList());
        }
        else {
            Comm.Instance().post("Vacation", rec).then(r => refreshList());
        }
    }

    const refreshList = () => {
        setRec(null);
        setRefresh(new Date());
    }

    const deleteVacation = (id) => {
        Comm.Instance().delete(`Vacation/${id}`).then(r => refreshList());
    }

    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Заместване</h2>
            {
                !rec && <button className="btn btn-primary" onClick={newVacation}>Нов запис</button>
            }
            {
                !rec && <VacationList users={users} editFunc={editVacation} refresh={refresh} delFunc={deleteVacation}></VacationList>
            }
            {
                rec && <VacationEdit rec={rec} setFunc={setFunc} saveFunc={save} cancelFunc={null} users={users} />
            }

        </div>



    );
}


export default Vacations;

